import { render, staticRenderFns } from "./Configuration_OmronFins.vue?vue&type=template&id=2bd5e91e"
import script from "./Configuration_OmronFins.vue?vue&type=script&lang=js"
export * from "./Configuration_OmronFins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports